/** @fileoverview Shows the documents sent with a message: name, type icon, and pages. */

import { pageLabel } from '../../lib/attachments';
import type { AttachmentData } from '../../types/chat';
import DeletedAttachment from './DeletedAttachment';
import FileTypeIcon from './FileTypeIcon';

export default function DocumentAttachments({ documents }: { documents: AttachmentData[] }) {
  return (
    <ul
      className="ml-auto flex max-w-full flex-col items-end gap-1.5"
      aria-label="Attached documents"
    >
      {documents.map((document) => {
        const name = document.name ?? 'Document';
        if (document.deleted) {
          return <DeletedAttachment key={document.id} name={name} status="deleted" />;
        }
        return (
          <li className="flex max-w-full min-w-0 flex-col items-end gap-0.5" key={document.id}>
            <span className="flex max-w-full min-w-0 items-center gap-2 rounded-lg border border-app-border bg-app-surface-muted px-2.5 py-1.5 text-xs text-app-text">
              <FileTypeIcon name={name} className="h-4 w-4 shrink-0 text-app-text-muted" />
              <span className="truncate" title={name}>
                {name}
              </span>
              <span className="shrink-0 text-app-text-muted">
                {pageLabel(name, document.pages) ?? ''}
              </span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
